import React from 'react';
import PropTypes from 'prop-types';
import gettext from '@eb/gettext';
import has from 'lodash/has';

import { withMainControls } from '@eb/eds-structure';
import { TYPE_ERROR } from '@eb/eds-notification';
import { AlertChunky } from '@eb/eds-iconography';
import { User } from '@eb/eds-iconography';

import AuthenticationStructure from '../../components/AuthenticationStructure';
import SetPasswordForm from '../../components/forms/SetPasswordForm';
import LookUpForm from '../../components/forms/LookUpForm';
import PageHeader from '../../components/PageHeader';

import { PASSWORD_SET_TOKEN } from '../../constants';

/**
 * List of urls that will lead to this page:
 * * BASE_URL/SET_PASSWORD_PATH
 */
class SetPasswordPage extends React.PureComponent {
    static propTypes = {
        handleSetPassword: PropTypes.func.isRequired,
        handleResetPassword: PropTypes.func.isRequired,
        locale: PropTypes.string,
        hideMainNotification: PropTypes.func,
        addMainNotification: PropTypes.func,
    };

    _handleShowNotification = (error) => {
        const { addMainNotification } = this.props;

        /*Limit the call to addMainNotification to only if
        a notification hasn't been shown since last submit.*/
        if (!this._hasNotification) {
            addMainNotification({
                type: TYPE_ERROR,
                children: error,
                iconType: <AlertChunky />,
            });

            this._hasNotification = true;
        }
    };

    _handleClearNotification = () => {
        const { hideMainNotification } = this.props;

        this._hasNotification = false;

        hideMainNotification && hideMainNotification();
    };

    render() {
        const {
            locale,
            router: {
                location: { query },
            },
            handleSetPassword,
            handleResetPassword,
        } = this.props;

        let submitAction = handleSetPassword;
        let DynamicForm = SetPasswordForm;

        const headerText = gettext('Create an account');
        const iconType = <User />;
        let buttonCTA = gettext('Sign up');
        let subtitleText = gettext(
            "You're almost there! Enter a password to complete your account.",
        );
        let shouldHideLegalCopy = true;

        // If the query includes paramters to reset the password, we trigger
        // the reset password form.
        // Not sure if this part is triggered in setPassword or resetPassword flow.
        if (!has(query, PASSWORD_SET_TOKEN)) {
            submitAction = handleResetPassword;
            DynamicForm = LookUpForm;
            buttonCTA = gettext('Send email');
            subtitleText = gettext(
                "Enter your email address and we'll send you a link to reset your password.",
            );
            shouldHideLegalCopy = false;
        }

        return (
            <AuthenticationStructure>
                <>
                    <PageHeader
                        headerText={headerText}
                        subtitleText={subtitleText}
                        iconType={iconType}
                    />
                    <DynamicForm
                        onSubmit={submitAction}
                        headerText={headerText}
                        iconType={iconType}
                        subtitleText={subtitleText}
                        buttonCTA={buttonCTA}
                        shouldHideLegalCopy={shouldHideLegalCopy}
                        locale={locale}
                        showNotification={this._handleShowNotification}
                        clearNotification={this._handleClearNotification}
                    />
                </>
            </AuthenticationStructure>
        );
    }
}

export default withMainControls(SetPasswordPage);
